import { render, staticRenderFns } from "./daily-sensor-compliance-card.vue?vue&type=template&id=23c07189&scoped=true&"
import script from "./daily-sensor-compliance-card.vue?vue&type=script&lang=js&"
export * from "./daily-sensor-compliance-card.vue?vue&type=script&lang=js&"
import style0 from "./daily-sensor-compliance-card.vue?vue&type=style&index=0&id=23c07189&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c07189",
  null
  
)

component.options.__file = "daily-sensor-compliance-card.vue"
export default component.exports